import type {UserGroupModulePermissionResponse} from 'src/api/ProactApiClient';
import {useAppSelector} from 'src/redux/hooks';

export const usePermissions = (): {
  permissions: UserGroupModulePermissionResponse[];
} => {
  const {session} = useAppSelector(i => i.session);
  const permissions = session?.user?.permissions ?? [];

  return {permissions};
};
